import { NativeModules } from 'react-native';
//useThemeValue非hooks用法
export const getThemeValue = (kidKey, customTheme) => {
    var _a, _b, _c, _d, _e;
    const theme = ((_b = (_a = NativeModules.KSAppearance) === null || _a === void 0 ? void 0 : _a.getColorScheme) === null || _b === void 0 ? void 0 : _b.call(_a)) || customTheme || 'light';
    if (!kidKey || typeof kidKey !== 'object') {
        return kidKey;
    }
    return ((_e = (_d = (_c = kidKey[customTheme || theme]) !== null && _c !== void 0 ? _c : kidKey[theme]) !== null && _d !== void 0 ? _d : kidKey.normal) !== null && _e !== void 0 ? _e : kidKey);
};
